/** @graphql cc **/

import gql from 'graphql-tag';

export const ContentUnifiedQuery = gql`
	query ContentUnifiedQuery(
		$contentId: ID!
		$spaceKey: String = null
		$versionOverride: Int
		$isSSR: Boolean = false
		$useNewContentTopper: Boolean = false
		$preloadLabels: Boolean = false
	) @allowHigherTimeout {
		content(id: $contentId, version: $versionOverride) {
			nodes {
				id
				status
				type
				subType
				title
				space {
					id
					key
					alias
				}
				version {
					confRev
					number
				}
				properties(
					keys: [
						"cover-picture-id-published"
						"editor"
						"import-source"
						"imported-page-modified-date"
					]
				) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				pageTitlePublished: properties(key: "page-title-property-published")
					@include(if: $useNewContentTopper) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				metadata {
					lastModifiedDate
					frontend {
						fabricEditorSupported
						coverPictureWidth @include(if: $useNewContentTopper)
					}
				}
				macroRenderedOutput @include(if: $isSSR) {
					key
					value {
						value
						representation
						webresource {
							tags {
								js
								css
							}
						}
					}
				}
				body {
					dynamic {
						representation
						value
						content {
							# Do not fetch 'id' here, so this version number is stored within 'body'
							# in GQL cache, separately from the shared 'content:[id]' cache entry.
							# This number is used to identify the correct version of cached 'body'.
							version {
								number
							}
						}
						webresource {
							superbatch {
								tags {
									js
									css
								}
							}
							tags {
								js
								css
							}
						}
					}
				}
				appearancePublished: properties(key: "content-appearance-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING })
					@include(if: $preloadLabels) {
					count
					nodes {
						id
						label
						name
						prefix
					}
				}
				operations @include(if: $preloadLabels) {
					operation
					targetType
				}
			}
		}
		space(key: $spaceKey) {
			id
			theme {
				name
				themeKey
			}
			lookAndFeel {
				content {
					screen {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						layer {
							background
							backgroundColor
							backgroundImage
							backgroundPosition
							backgroundSize
							backgroundRepeat
							backgroundOrigin
							backgroundClip
							backgroundAttachment
							backgroundBlendMode
							width
							height
						}
						gutterTop
						gutterRight
						gutterBottom
						gutterLeft
					}
					container {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						padding
						borderRadius
					}
				}
			}
			settings {
				routeOverrideEnabled
			}
			currentUser {
				isAnonymouslyAuthorized
			}
		}
	}
`;
